// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/Gilroy-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/Gilroy-ExtraBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/Gilroy-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "bold-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "bold-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "semi-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: "semi-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-Poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
@font-face {
  font-family: "med-Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
@font-face {
  font-family: "bold-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
@font-face {
  font-family: "extra-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
@font-face {
  font-family: "semi-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: "med-gilory";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.SideDrawer_sideDrawer__qmEoK {
  width: 340px;
  height: 100%;
  background: var(--sb-bg-color);
  border: 1px solid var(--sb-bg-color);
  position: fixed;
  flex-wrap: wrap;
  z-index: 11;
  top: 0;
  right: 0;
  bottom: 0;
  transition: transform 0.4s ease-out;
  padding: 14px 17px 21px;
  overflow-y: auto;
  overflow-x: hidden;
}
.SideDrawer_sideDrawer__qmEoK a {
  text-decoration: unset;
}

.SideDrawer_closeIcon__eRYYj:hover svg {
  fill: #e0e0ff;
}

.SideDrawer_open__Boya0 {
  transform: translateX(0);
}

.SideDrawer_close__3KIII {
  transform: translateX(150%);
}

.SideDrawer_logo__xT8zu {
  margin: 60px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.SideDrawer_navItems__shOdc {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.SideDrawer_headerItems__M2KKT {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.SideDrawer_headerItems__M2KKT button {
  background-color: transparent;
}
.SideDrawer_headerItems__M2KKT a {
  text-decoration: none;
  color: unset;
}
.SideDrawer_headerItems__M2KKT .SideDrawer_listItem__ygjWC {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.SideDrawer_headerItems__M2KKT .SideDrawer_listItem__ygjWC .SideDrawer_rightSide__2Qzus {
  display: flex;
  align-items: center;
  gap: 12px;
}
.SideDrawer_headerItems__M2KKT .SideDrawer_listItem__ygjWC .SideDrawer_rightSide__2Qzus img {
  height: 24px;
}
.SideDrawer_headerItems__M2KKT .SideDrawer_listItem__ygjWC .SideDrawer_rightSide__2Qzus .SideDrawer_subTitle__Mr7Q8 {
  color: rgba(20, 16, 41, 0.6);
  font-size: 14px;
  line-height: 24px;
  font-family: "med-Montserrat";
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.SideDrawer_headerItems__M2KKT .SideDrawer_listItem__ygjWC .SideDrawer_rightSide__2Qzus .SideDrawer_badge__0XwRV {
  color: #ffffff;
  font-size: 13px;
  line-height: 16px;
  font-family: "semi-gilory";
  font-weight: 600;
  background-color: #5d2de1;
  border-radius: 9px;
  padding: 2px 4px 0;
}

.SideDrawer_leftSide__Ciemh {
  display: flex;
  align-items: center;
  gap: 16px;
  outline: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
.SideDrawer_leftSide__Ciemh img {
  width: 24px;
  border-radius: 50%;
}
.SideDrawer_leftSide__Ciemh span {
  color: rgba(20, 16, 41, 0.8);
  font-size: 14px;
  line-height: 24px;
  font-family: "med-Montserrat";
  font-weight: 500;
}

@media (min-width: 780px) {
  .SideDrawer_sideDrawer__qmEoK {
    display: none;
  }
}
@media (max-width: 450px) {
  .SideDrawer_sideDrawer__qmEoK {
    width: 100%;
  }
  .SideDrawer_navContainer__MpXqb {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/_variables.scss","webpack://./src/components/Layouts/DashboardLayout/SideDrawer/SideDrawer.module.scss"],"names":[],"mappings":"AA4CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,8BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,6BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,2BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,0BAAA;EACA,4CAAA;AC3CF;AD6CA;EACE,yBAAA;EACA,4CAAA;AC3CF;AArCA;EACE,YAAA;EACA,YAAA;EACA,8BAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAuCF;AArCE;EACE,sBAAA;AAuCJ;;AAnCA;EACE,aAAA;AAsCF;;AAnCA;EACE,wBAAA;AAsCF;;AAnCA;EACE,2BAAA;AAsCF;;AAnCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAsCF;;AApCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAuCF;;AApCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAuCF;AAtCE;EACE,6BAAA;AAwCJ;AAtCE;EACE,qBAAA;EACA,YAAA;AAwCJ;AAtCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAwCJ;AAvCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAyCN;AAxCM;EACE,YAAA;AA0CR;AAxCM;EACE,4BAAA;EACA,eDpDO;ECqDP,iBD1CS;EC2CT,6BDgBe;ECff,gBDpCK;ECqCL,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA0CR;AAxCM;EACE,cD7EM;EC8EN,eDhEO;ECiEP,iBDvDS;ECwDT,0BDQkB;ECPlB,gBD9CG;EC+CH,yBDtFQ;ECuFR,kBAAA;EACA,kBAAA;AA0CR;;AArCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EAYA,eAAA;AA6BF;AAxCE;EACE,WAAA;EACA,kBAAA;AA0CJ;AAxCE;EACE,4BDtGc;ECuGd,eDvFW;ECwFX,iBD7Ea;EC8Eb,6BDnBmB;ECoBnB,gBDvES;ACiHb;;AArCA;EACE;IACE,aAAA;EAwCF;AACF;AArCA;EACE;IACE,WAAA;EAuCF;EApCA;IACE,WAAA;IACA,aAAA;IACA,uBAAA;EAsCF;AACF","sourcesContent":["// colors\n$primary-color: #5d2de1;\n$dark-color: #141029;\n$cultured-color: #f5f7fa;\n$dark-text-color: rgba(20, 16, 41, 0.8);\n$white-color: #ffffff;\n$card-gradient-color: linear-gradient(\n  135deg,\n  #ffffff 0%,\n  #fafbfc 51.82%,\n  #f5f7fa 100%\n);\n$pink-color: #e0e0ff;\n$white-color-40: rgba(255, 255, 255, 0.4);\n$white-color-4: rgba(224, 224, 255, 0.04);\n$danger-color: #f54562;\n\n// fonts\n\n$font-size-xs: 13px;\n$font-size-sm: 14px;\n$font-size-md: 16px;\n$font-size-xm: 18px;\n$font-size-lg: 20px;\n$font-size-xl: 24px;\n$font-size-xxl: 30px;\n$font-size-3xl: 36px;\n$font-size-4xl: 48px;\n\n$font-height-xs: 16px;\n$font-height-sm: 20px;\n$font-height-md: 24px;\n$font-height-xm: 28px;\n$font-height-lg: 30px;\n$font-height-xl: 32px;\n$font-height-xxl: 36px;\n$font-height-3xl: 40px;\n$font-height-4xl: 48px;\n\n$font-light: 500;\n$font-med: 600;\n$font-bold: 700;\n$font-extra: 800;\n\n@font-face {\n  font-family: \"bold-Poppins\";\n  src: url(/assets/fonts/Poppins-Bold.ttf);\n}\n@font-face {\n  font-family: \"bold-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Bold.ttf);\n}\n@font-face {\n  font-family: \"semi-Poppins\";\n  src: url(/assets/fonts/Poppins-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"semi-Montserrat\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-Poppins\";\n  src: url(/assets/fonts/Poppins-Medium.ttf);\n}\n@font-face {\n  font-family: \"med-Montserrat\";\n  src: url(/assets/fonts/Montserrat-Medium.ttf);\n}\n@font-face {\n  font-family: \"bold-gilory\";\n  src: url(/assets/fonts/Gilroy-Bold.ttf);\n}\n@font-face {\n  font-family: \"extra-gilory\";\n  src: url(/assets/fonts/Gilroy-ExtraBold.otf);\n}\n@font-face {\n  font-family: \"semi-gilory\";\n  src: url(/assets/fonts/Montserrat-SemiBold.ttf);\n}\n@font-face {\n  font-family: \"med-gilory\";\n  src: url(/assets/fonts/Gilroy-Medium.ttf);\n}\n\n$title-font-family-bold: \"bold-Poppins\";\n$title-font-family-semi: \"semi-Poppins\";\n$title-font-family-med: \"med-Poppins\";\n$text-font-family-bold: \"bold-Montserrat\";\n$text-font-family-semi: \"semi-Montserrat\";\n$text-font-family-med: \"med-Montserrat\";\n$number-font-family-bold: \"bold-gilory\";\n$number-font-family-extra: \"extra-gilory\";\n$number-font-family-semi: \"semi-gilory\";\n$number-font-family-med: \"med-gilory\";\n\n// dark and light theme\n$dark-bg-color: #111315; // background\n$dark-sb-bg-color: #242527; // sidebar\n\n$light-bg-color: #F4F4F4; // background\n$light-sb-bg-color: #FCFCFC; // sidebar","@import \"/src/assets/stylesheets/variables\";\n\n.sideDrawer {\n  width: 340px;\n  height: 100%;\n  background: var(--sb-bg-color);\n  border: 1px solid var(--sb-bg-color);\n  position: fixed;\n  flex-wrap: wrap;\n  z-index: 11;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  transition: transform 0.4s ease-out;\n  padding: 14px 17px 21px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  a {\n    text-decoration: unset;\n  }\n}\n\n.closeIcon:hover svg {\n  fill: #e0e0ff;\n}\n\n.open {\n  transform: translateX(0);\n}\n\n.close {\n  transform: translateX(150%);\n}\n\n.logo {\n  margin: 60px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.navItems {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.headerItems {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  button {\n    background-color: transparent;\n  }\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  .listItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .rightSide {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      img {\n        height: 24px;\n      }\n      .subTitle {\n        color: rgba(20, 16, 41, 0.6);\n        font-size: $font-size-sm;\n        line-height: $font-height-md;\n        font-family: $text-font-family-med;\n        font-weight: $font-light;\n        max-width: 100px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      .badge {\n        color: $white-color;\n        font-size: $font-size-xs;\n        line-height: $font-height-xs;\n        font-family: $number-font-family-semi;\n        font-weight: $font-med;\n        background-color: $primary-color;\n        border-radius: 9px;\n        padding: 2px 4px 0;\n      }\n    }\n  }\n}\n.leftSide {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  outline: none;\n  border: none;\n  background-color: transparent;\n  img {\n    width: 24px;\n    border-radius: 50%;\n  }\n  span {\n    color: $dark-text-color;\n    font-size: $font-size-sm;\n    line-height: $font-height-md;\n    font-family: $text-font-family-med;\n    font-weight: $font-light;\n  }\n  cursor: pointer;\n}\n\n@media (min-width: 780px) {\n  .sideDrawer {\n    display: none;\n  }\n}\n\n@media (max-width: 450px) {\n  .sideDrawer {\n    width: 100%;\n  }\n\n  .navContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideDrawer": `SideDrawer_sideDrawer__qmEoK`,
	"closeIcon": `SideDrawer_closeIcon__eRYYj`,
	"open": `SideDrawer_open__Boya0`,
	"close": `SideDrawer_close__3KIII`,
	"logo": `SideDrawer_logo__xT8zu`,
	"navItems": `SideDrawer_navItems__shOdc`,
	"headerItems": `SideDrawer_headerItems__M2KKT`,
	"listItem": `SideDrawer_listItem__ygjWC`,
	"rightSide": `SideDrawer_rightSide__2Qzus`,
	"subTitle": `SideDrawer_subTitle__Mr7Q8`,
	"badge": `SideDrawer_badge__0XwRV`,
	"leftSide": `SideDrawer_leftSide__Ciemh`,
	"navContainer": `SideDrawer_navContainer__MpXqb`
};
export default ___CSS_LOADER_EXPORT___;
